<template>
    <div class="watchdetail-child2">
        <div class="watchdetail-child2-header" v-if="activeName2=='first'">
            <div class="step">
                <span>今日步数：</span>
                <span>{{stepTotalDay}}</span>
                </div>
            <div class="shuju">
                    <span class="shujukm">距离：  {{kilometerTotalDay}}</span>
                    <span class="shujukcal">卡路里：  {{calorieTotalDay}}</span>
            </div>
        </div>
        <div class="watchdetail-child2-header" v-if="activeName2=='second'">
            <div class="step">
                <span>本周步数：</span>
                <span>{{stepTotalWeek}}</span>
                </div>
            <div class="shuju">
                    <span class="shujukm">距离：  {{kilometerTotalWeek}}</span>
                    <span class="shujukcal">卡路里：  {{calorieTotalWeek}}</span>
            </div>
        </div>
        <div class="watchdetail-child2-header" v-if="activeName2=='third'">
            <div class="step">
                <span>本月步数：</span>
                <span>{{stepTotalMonth}}</span>
                </div>
            <div class="shuju">
                    <span class="shujukm">距离：  {{kilometerTotalMonth}}</span>
                    <span class="shujukcal">卡路里：  {{calorieTotalMonth}}</span>
            </div>
        </div>
        <div class="watchdetail-child2-main" style="position: relative;">
            <div class="watchdetail-child2-main-a">
                <el-tabs v-model="activeName2" class="echart" type="border-card" @tab-click="handleClick">
                    <el-tab-pane label="日" name="first">
                        <div v-if="activeName2 == 'first'" id="myChartDay" ref="myChartDay" style="width:850px; height:400px;" class="myChartDay">
                            <!-- 存放echart的实例数据-->
                        </div>      
                    </el-tab-pane>
                    <el-tab-pane label="周" name="second">
                        <div v-if="activeName2 == 'second'" id="myChartWeek" ref="myChartWeek" style="width:850px; height:400px;" class="myChartWeek">
                            <!-- 存放echart的实例数据-->
                        </div>   
                    </el-tab-pane>
                    <el-tab-pane label="月" name="third">
                         <div v-if="activeName2 == 'third'" id="myChartMonth" ref="myChartMonth" style="width:850px; height:400px;" class="myChartMonth">
                            <!-- 存放echart的实例数据-->
                        </div>   
                    </el-tab-pane>
                </el-tabs>
                <div style="position:absolute;top:0;right:10px;width:230px;z-index:999;">
                    <el-date-picker
                    v-model="dataPick"
                    type="date"
                    @change="changeData"
                    :picker-options="pickerOptions"
                    value-format="yyyy-MM-dd"
                    placeholder="选择日期">
                    </el-date-picker>
                </div>
            </div>
        </div>
    </div>
</template>
<script type="text/javascript">
import echarts from 'echarts'
import util from '@/utils/util.js'
export default {
    data() {
        return {
            activeName2: 'first',
            deviceId:this.$route.query.id,//设备id
            dataPick:util.formatDate.format(new Date(), 'yyyy-MM-dd'),//选取的时间的值
            stepTotalDay:'',//天运动的步数
            calorieTotalDay:'',//天运动的卡路里
            kilometerTotalDay:'',//天运动的路程km
            stepHour:[],//一天每个小时的步数
            calorieHour:[],//一天每小时的卡路里
            kilometerHour:[],//一天每个小时的路程
            stepTotalWeek:'',//周运动的步数
            calorieTotalWeek:'',//周运动的卡路里
            kilometerTotalWeek:'',//周运动的路程km
            stepDay:[],//一周每天的步数
            calorieDay:[],//一周每天的卡路里
            kilometerDay:[],//一周每天的路程
            stepTotalMonth:'',//月运动的步数
            calorieTotalMonth:'',//月运动的卡路里
            kilometerTotalMonth:'',//月运动的路程km
            stepMonth:[],//一个月每天的步数
            calorieMonth:[],//一个月每天的卡路里
            kilometerMonth:[],//一个月每天的路程
            pickerOptions:{
                disabledDate(time) {
                    return time.getTime() > Date.now();
                },
            },
        };
    },
    methods: {
        //左侧切换tab
        handleClick(tab, event) {
            console.log(tab, event,this.activeName2);
            this.drawChart();//点击时再调用 
        },
        //选取的时间
        changeData(value){
            console.log(value);
            this.dataPick=value;
            this.drawChart()
        },
        //获取天的运动信息
        drawDay(){
            console.log(this.$refs.myChartDay)
            // 基于准备好的dom，初始化echarts实例
            var chartDay=this.$refs.myChartDay;
            if(chartDay){
                 let myChartDay=echarts.init(chartDay)
                // 绘制图表
                myChartDay.setOption({
                    title: {
                        text: '日运动信息'
                    },
                    tooltip: {
                        trigger: 'axis'
                    },
                    legend: {
                        data:['运动距离','消耗卡路里','运动步数']
                    },
                    grid: {
                        left: '3%',
                        right: '4%',
                        bottom: '3%',
                        containLabel: true
                    },
                    toolbox: {
                        //x:'610',//下载的字体显示不全
                        x:'90%',//下载的字体显示不全
                        feature: {
                            saveAsImage: {}
                        }
                    },
                    xAxis: {
                        type: 'category',
                        boundaryGap: false,
                        data: ['0', '1', '2', '3', '4', '5', '6','7','8','9','10','11','12','13','14','15','16','17','18','19','20','21','22','23']
                    },
                    yAxis: {
                        type: 'value'
                    },
                    series: [
                       {
                            name:'运动距离',
                            type:'line',
                            data:[120, 132, 101, 134, 90, 230, 210,220, 182, 191, 234, 290, 330, 310,150, 232, 201, 154, 190, 330, 410,220, 182, 191,150, 232, 201] 
                        },
                        {
                            name:'消耗卡路里',
                            type:'line',
                            data:[220, 182, 191, 234, 290, 330, 310,120, 132, 101, 134, 90, 230,150, 232, 201, 154, 190, 330, 410,232, 201, 154, 190, 330, 410]
                        },
                        {
                            name:'运动步数',
                            type:'line',
                            data:[150, 232, 201, 154, 190, 330, 410,220,330, 410,232,290, 330,120, 132, 101, 134, 90, 230,154, 190, 330, 410,232, 201, 154]
                        },
                    ]
                });
                myChartDay.showLoading();//加载动画
                //传参 axios发起数据请求
                let parma={
                    deviceId:this.deviceId*1,
                    date:this.dataPick
                }
                console.log(parma)
                this.stepHour=[];
                this.calorieHour=[];
                this.kilometerHour=[];
                this.$postJson('dmc/watch/queryHistStepWithDay',parma).then((res)=>{
                    console.log(res);
                    this.calorieTotalDay=res.result.calorieTotal+'cal';
                    this.kilometerTotalDay=res.result.kilometerTotal+'km';
                    this.stepTotalDay=res.result.stepTotal+'步';
                    res.result.hourVoList.forEach((item,index) => {
                        console.log(item);
                        this.stepHour.push(item.step)
                        this.calorieHour.push(item.calorie)
                        this.kilometerHour.push(item.kilometer)
                    });
                    console.log(this.stepHour);
                    console.log(this.calorieHour);
                    console.log(this.kilometerHour);
                    if( this.calorieTotalDay>0 || this.kilometerTotalDay>0 ||  this.stepTotalDay>0){
                        setTimeout(()=>{
                            myChartDay.hideLoading();//加载成功关闭动画
                        },100)
                    }else{
                        setTimeout(()=>{
                            myChartDay.hideLoading();//加载成功关闭动画
                        },500) 
                    }
                    //将后台获取的值注入data中，echaert图形展示获取的数据
                    myChartDay.setOption({
                         series: [
                            {
                                name:'运动距离',
                                type:'line',
                                data:this.kilometerHour
                            },
                            {
                                name:'消耗卡路里',
                                type:'line',
                                data:this.calorieHour
                            },
                            {
                                name:'运动步数',
                                type:'line',
                                data:this.stepHour
                            },
                        ]
                    })
                })
            }    
        },
        //获取周的运动信息
        drawWeek(){
            console.log(this.$refs.myChartWeek)
            // 基于准备好的dom，初始化echarts实例
            var chartWeek=this.$refs.myChartWeek;
            if(chartWeek){
                 let myChartWeek=echarts.init(chartWeek)
                // 绘制图表
                myChartWeek.setOption({
                    title: {
                        text: '周运动信息'
                    },
                    tooltip: {
                        trigger: 'axis'
                    },
                    legend: {
                        data:['运动距离','消耗卡路里','运动步数']
                    },
                    grid: {
                        left: '3%',
                        right: '4%',
                        bottom: '3%',
                        containLabel: true
                    },
                    toolbox: {
                        //x:'610',//下载的字体显示不全
                        x:'90%',//下载的字体显示不全
                        feature: {
                            saveAsImage: {}
                        }
                    },
                   xAxis: {
                        type: 'category',
                        boundaryGap: false,
                        data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
                    },
                    yAxis: {
                        type: 'value'
                    },
                    series: [
                        {
                            name:'运动距离',
                            type:'line',
                            data:[120, 132, 101, 134, 90, 230, 210]
                        },
                        {
                            name:'消耗卡路里',
                            type:'line',
                            data:[220, 182, 191, 234, 290, 330,200]
                        },
                        {
                            name:'运动步数',
                            type:'line',
                            data:[150, 232, 201, 154, 190, 330,400]
                        },
                    ]
                });
                myChartWeek.showLoading();//加载动画
                //传参 axios发起数据请求
                let parma={
                    deviceId:this.deviceId*1,
                    date:this.dataPick
                }
                console.log(parma)
                this.stepWeek=[];
                this.calorieWeek=[];
                this.kilometerWeek=[];
                this.$postJson('dmc/watch/queryHistStepWithWeek',parma).then((res)=>{
                    console.log(res);
                    this.calorieTotalWeek=res.result.calorieTotal+'cal';
                    this.kilometerTotalWeek=res.result.kilometerTotal+'km';
                    this.stepTotalWeek=res.result.stepTotal+'步';
                    res.result.dayVoList.forEach((item,index) => {
                        console.log(item);
                        this.stepWeek.push(item.step)
                        this.calorieWeek.push(item.calorie)
                        this.kilometerWeek.push(item.kilometer)
                    });
                    console.log(this.stepWeek);
                    console.log(this.calorieWeek);
                    console.log(this.kilometerWeek);
                    myChartWeek.hideLoading();//加载成功关闭动画
                    //将后台获取的值注入data中，echaert图形展示获取的数据
                    myChartWeek.setOption({
                         series: [
                            {
                                name:'运动距离',
                                type:'line',
                                data:this.kilometerWeek
                            },
                            {
                                name:'消耗卡路里',
                                type:'line',
                                data:this.calorieWeek
                            },
                            {
                                name:'运动步数',
                                type:'line',
                                data:this.stepWeek
                            },
                        ]
                    })
                })
            } 
        },
        //获取月的运动信息
        drawMonth(){
            // 基于准备好的dom，初始化echarts实例
            var chartMonth=this.$refs.myChartMonth;
            if(chartMonth){
                 let myChartMonth=echarts.init(chartMonth)
                // 绘制图表
                myChartMonth.setOption({
                    title: {
                        text: '月运动信息'
                    },
                    tooltip: {
                        trigger: 'axis'
                    },
                    legend: {
                        data:['运动距离','消耗卡路里','运动步数']
                    },
                    grid: {
                        left: '3%',
                        right: '4%',
                        bottom: '3%',
                        containLabel: true
                    },
                    toolbox: {
                        //x:'610',//下载的字体显示不全
                        x:'90%',//下载的字体显示不全
                        feature: {
                            saveAsImage: {}
                        }
                    },
                    xAxis: {
                        type: 'category',
                        boundaryGap: false,
                        data: ['1', '2', '3', '4', '5', '6','7','8','9','10','11','12','13','14','15','16','17','18','19','20','21','22','23','24','25','26','27','28','29','30','31']
                    },
                    yAxis: {
                        type: 'value'
                    },
                    series: [
                        {
                            name:'运动距离',
                            type:'line',
                            data:[120, 132, 101, 134, 90, 230, 210,120, 132, 101, 134, 90, 230, 210,120, 132, 101, 134, 90, 230, 210,120, 132, 101, 134, 90, 230, 210,120, 132, 101]
                        },
                        {
                            name:'消耗卡路里',
                            type:'line',
                             data:[220, 182, 191, 234, 290, 330, 310,220, 182, 191, 234, 290, 330, 310,220, 182, 191, 234, 290, 330, 310,220, 182, 191, 234, 290, 330, 310,220, 182, 191, 234, 290, 330]
                        },
                        {
                            name:'运动步数',
                            type:'line',
                            data:[150, 232, 201, 154, 190, 330, 410,150, 232, 201, 154, 190, 330, 410,150, 232, 201, 154, 190, 330, 410,150, 232, 201, 154, 190, 330, 410,150, 232, 201]
                        },
                    ]
                });
                myChartMonth.showLoading();//加载动画
                //传参 axios发起数据请求
                let parma={
                    deviceId:this.deviceId*1,
                    date:this.dataPick
                }
                console.log(parma)
                this.stepMonth=[];
                this.calorieMonth=[];
                this.kilometerMonth=[];
                this.$postJson('dmc/watch/queryHistStepWithMonth',parma).then((res)=>{
                    console.log(res);
                    this.calorieTotalMonth=res.result.calorieTotal+'cal';
                    this.kilometerTotalMonth=res.result.kilometerTotal+'km';
                    this.stepTotalMonth=res.result.stepTotal+'步';
                     res.result.dayVoList.forEach((item,index) => {
                        console.log(item);
                        this.stepMonth.push(item.step)
                        this.calorieMonth.push(item.calorie)
                        this.kilometerMonth.push(item.kilometer)
                    });
                    console.log(this.stepMonth);
                    console.log(this.calorieMonth);
                    console.log(this.kilometerMonth);
                    myChartMonth.hideLoading();//加载成功关闭动画
                    //将后台获取的值注入data中，echaert图形展示获取的数据
                    myChartMonth.setOption({
                         series: [
                            {
                                name:'运动距离',
                                type:'line',
                                data:this.kilometerMonth
                            },
                            {
                                name:'消耗卡路里',
                                type:'line',
                                data:this.calorieMonth
                            },
                            {
                                name:'运动步数',
                                type:'line',
                                data:this.stepMonth
                            },
                        ]
                    })
                    setTimeout( () => {
                       myChartMonth.resize();
                    })
                })
            }
        },
        drawChart(){
            //延迟加载 否则tab第二个和第三个无法正常显示
            this.$nextTick(()=>{
                setTimeout(()=>{
                    this.drawDay();
                    this.drawWeek();
                    this.drawMonth();
                },10)
            })
           
        }
    },
    created(){
        this.drawChart();//组件传创建时调用
    },
    mounted(){
        this.drawChart();//组件加载时调用
    },
}
</script>
<style lang="scss" scoped>
    .watchdetail-child2{
        width:98%;
        height:98%;
        margin:1%;
        .watchdetail-child2-header{
            height:20%;
            padding:5px;
            border:1px solid rgb(243, 234, 234);;
            display:flex;
            flex-direction: column;
            align-items: center;
            .step{
                display: flex;
                justify-content: center;
                align-items: center;
                height:50%;
                font-size:16px;
                color:rgb(100, 92, 92);
            }
            .shuju{
                height:50%;
                width:60%;
                display: flex;
                font-size:16px;
                 flex-direction: row;
                justify-content:space-between;
                align-items: center;
                color:rgb(100, 92, 92);
                .shujukm{
                    text-align:center;
                    width:50%;
                }
                .shujukcal{
                    width:50%;
                    text-align: center;
                }
            }
        }
        .watchdetail-child2-main{
            height:76%;
            margin-top:10px;
            border:1px solid rgb(243, 234, 234);
        
        }
    }
    ::v-deep .el-tabs__nav-scroll{
        display: flex;
        justify-content: center;
    }

    @media screen and (min-width:1000px) and (max-width:1530px){
        ::v-deep #myChartDay {
            //width:660px !important;
            width:99% !important;
        }
    }
    @media screen and (min-width:1531px) and (max-width:1920px){
         ::v-deep #myChartDay {
            //width:850px !important;
            width:99% !important;
        }
    }

    @media screen and (min-width:1921px) {
         ::v-deep #myChartDay {
            //width:1200px !important;
            width:99% !important;
        }
    }

    
    @media screen and (min-width:1000px) and (max-width:1530px){
        ::v-deep #myChartWeek {
            //width:660px !important;
            width:99% !important;
        }
    }
    @media screen and (min-width:1531px) and (max-width:1920px){
         ::v-deep #myChartWeek {
            //width:850px !important;
            width:99% !important;
        }
    }

    @media screen and (min-width:1921px) {
         ::v-deep #myChartWeek {
            //width:1200px !important;
            width:99% !important;
        }
    }

    
    @media screen and (min-width:1000px) and (max-width:1530px){
        ::v-deep #myChartMonth {
            //width:660px !important;
            width:99% !important;
        }
    }
    @media screen and (min-width:1531px) and (max-width:1920px){
         ::v-deep #myChartMonth {
            //width:850px !important;
            width:99% !important;
        }
    }

    @media screen and (min-width:1921px) {
         ::v-deep #myChartMonth {
            //width:1200px !important;
            width:99% !important;
        }
    }
</style>
